import { render, staticRenderFns } from "./ModalidadesEmbarques.vue?vue&type=template&id=55d6c0b5"
import script from "./ModalidadesEmbarques.vue?vue&type=script&lang=js"
export * from "./ModalidadesEmbarques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports